import * as K from './SalesConstants';
import Fuse from 'fuse.js';
import immutable from 'object-path-immutable';
import floopback from 'lib/floopback';
import feathers from '../../../feathers';
import moment from 'moment';
import axios from 'axios';
import auth from '../../../lib/auth';

var Sales = new floopback('sales');
let startDate = '',
  finalDate = '';

export function setState(value) {
  return {
    type: K.SETSTATE,
    payload: value,
  };
}

export function onChange(path, value) {
  return {
    type: K.ON_CHANGE,
    payload: {
      path: path,
      value: value,
    },
  };
}

export function stateInit(value) {
  return {
    type: K.STATEINIT,
  };
}

export function find(params) {
  let _this = this;
  return (dispatch, getState) => {
    dispatch({
      type: K.FIND,
      payload: Sales.find(params),
    }).then(function (result) {
      _this.searchTable(getState().Sales.search);
    });
  };
}

export function count(where = {}) {
  return async () => {
    try {
      const filter = JSON.stringify(where);
      const res = await axios.get(
        `${process.env.REACT_APP_URL_API}/api/sales/count?where=${filter}`
      );
      return res.data.count;
    } catch (error) {
      console.error('Error al contar ventas:', error);
      return 0;
    }
  };
}

export function findByNameDates(params) {
  let _this = this;
  const { nameSearch, startDate, endDate, franchiseId } = params;

  let findDateStart = moment(startDate, 'YYYY-MM-DD')
    .startOf('day')
    .utc()
    .format('YYYY-MM-DD HH:mm:ss');

  let findDateEnd = moment(endDate, 'YYYY-MM-DD')
    .endOf('day')
    .utc()
    .format('YYYY-MM-DD HH:mm:ss');

  return async (dispatch, getState) => {
    const CurrentSale = await feathers.service('sales').find({
      query: {
        franchiseId: franchiseId,
        $populate: [
          {
            path: 'salesInformation.assignedTo',
            match: {
              _id: { $ne: null },
            },
          },
          {
            path: 'clientId',
            match: { _id: { $ne: null } },
          },
        ],
        dateSaleNote: { $exists: true },
        dateSaleNote: {
          $gte: findDateStart,
          $lte: findDateEnd,
        },
        $sort: {
          createdAt: -1,
        },
      },
    });

    let data = [];
    if (CurrentSale && CurrentSale.total > 0) {
      data = CurrentSale.data.filter(
        (sales) =>
          sales &&
          sales.salesInformation &&
          sales.salesInformation.assignedTo &&
          sales.salesInformation.assignedTo.firstName === nameSearch,
      );
    }

    dispatch({
      type: K.FIND + '_FULFILLED',
      payload: data,
    });
  };
}

export function findById(id) {
  return async (dispatch, getState) => {
    const CurrentSale = await feathers.service('sales').get(id, {
      query: {
        $populate: [
          {
            path: 'clientId',
          },
          {
            path: 'assignedTo',
          },
          {
            path: 'salesInformation.assignedTo',
          },
          {
            path: 'lodging.hotel',
          },
          {
            path: 'lodging.operator',
          },
          {
            path: 'flights.operator',
          },
          {
            path: 'packages.operator',
          },
          {
            path: 'otherServicesSale.operator',
          },
          {
            path: 'franchiseId',
          },
        ],
      },
    });

    var newSale = immutable.set(
      getState().Sales,
      ['salesInformation', 'clientId'],
      CurrentSale.clientId,
    );

    newSale = immutable.set(newSale, 'clientId', CurrentSale.clientId._id);
    newSale = immutable.set(newSale, 'clientDefault', CurrentSale.clientId);

    //Franchise
    newSale = immutable.set(
      newSale,
      'franchiseId',
      CurrentSale.franchiseId._id,
    );
    newSale = immutable.set(
      newSale,
      'franchiseDefault',
      CurrentSale.franchiseId,
    );

    var CurrentClient =
      CurrentSale.client !== undefined ? CurrentSale.client : {};

    newSale = immutable.set(newSale, 'client', CurrentClient);

    newSale = immutable.set(newSale, 'optionsSelect.client', [
      {
        value: CurrentClient.id,
        label:
          (CurrentClient.firstName ? CurrentClient.firstName : '') +
          ' ' +
          (CurrentClient.lastName ? CurrentClient.lastName : ''),
      },
    ]);

    newSale = immutable.set(
      newSale,
      'salesInformation',
      CurrentSale.salesInformation,
    );
    newSale = immutable.set(
      newSale,
      'salesInformation.statusId',
      CurrentSale.prefix,
    );

    newSale = immutable.set(newSale, 'folio', CurrentSale.folio);
    newSale = immutable.set(newSale, 'prefolio', CurrentSale.prefolio);

    newSale = immutable.set(newSale, 'id', CurrentSale._id);
    newSale = immutable.set(newSale, 'assignedTo', CurrentSale.assignedTo._id);
    newSale = immutable.set(
      newSale,
      'assignedToDefault',
      CurrentSale.assignedTo,
    );
    newSale = immutable.set(newSale, 'quotationId', CurrentSale.quotationId);
    newSale = immutable.set(newSale, 'flights', CurrentSale.flights);
    newSale = immutable.set(newSale, 'lodgings', CurrentSale.lodging);
    newSale = immutable.set(newSale, 'packages', CurrentSale.packages);
    newSale = immutable.set(newSale, 'type', CurrentSale.type);
    newSale = immutable.set(
      newSale,
      'otherServicesSale',
      CurrentSale.otherServicesSale,
    );
    newSale = immutable.set(
      newSale,
      'operatorsPaymentSale',
      CurrentSale.operatorsPaymentSale,
    );
    newSale = immutable.set(newSale, 'receipts', CurrentSale.receipts);
    newSale = immutable.set(newSale, 'balance', CurrentSale.balance || {});
    newSale = immutable.set(newSale, 'dateSaleNote', CurrentSale.dateSaleNote);
    newSale = immutable.set(newSale, 'loading', false);

    if (
      CurrentSale.salesInformation &&
      CurrentSale.salesInformation.limitDate
    ) {
      const saleDate = moment(CurrentSale.salesInformation.limitDate).utc();
      const now = moment().utc();

      const differenceInDays = saleDate.diff(now, 'days', true);

      const roundedDifferenceInDays = Math.floor(differenceInDays);

      let color = '';

      if (roundedDifferenceInDays < 7 && roundedDifferenceInDays >= 2) {
        color = 'Yellow';
      } else if (roundedDifferenceInDays < 2 && roundedDifferenceInDays >= 0) {
        color = 'Red';
      }

      newSale = immutable.set(
        newSale,
        'salesInformation.limitDateColor',
        color,
      );
    }

    dispatch({
      type: K.SETSTATE,
      payload: newSale,
    });
  };
}

export function create(formData) {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      dispatch({ type: K.CREATE + '_PENDING', payload: formData });
      Sales.create(formData)
        .then(function (data) {
          dispatch({ type: K.CREATE + '_FULFILLED', payload: data });
          resolve(data);
        })
        .catch(function (error) {
          dispatch({ type: K.CREATE + '_REJECTED', payload: error });
          reject(error);
        });
    });
  };
}

export function update(id, formData) {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      dispatch({ type: K.UPDATE + '_PENDING', payload: formData });
      Sales.update(id, formData)
        .then(function (data) {
          dispatch({ type: K.UPDATE + '_FULFILLED', payload: data });
          resolve(data);
        })
        .catch(function (error) {
          dispatch({ type: K.UPDATE + '_REJECTED', payload: error });
          reject(error);
        });
    });
  };
}

export function remove(id, formData) {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      dispatch({ type: K.DELETE + '_PENDING' });
      //DONE - Paty*** Con feathers hacer que solo se ponga un "delete:true" y que en la parte de editar, aparezca como borrado (esta en SalesForm porque es un update)
      Sales.delete(id)
        .then(function (data) {
          dispatch({ type: K.DELETE + '_FULFILLED', payload: data });
          resolve(data);
        })
        .catch(function (error) {
          dispatch({ type: K.DELETE + '_REJECTED', payload: error });
          reject(error);
        });
    });
  };
}

export function changeTable(feature, value) {
  return (dispatch, getState) => {
    dispatch({
      type: K.CHANGE_TABLE,
      payload: {
        feature: feature,
        value: value,
      },
    });
  };
}

let currentSearchRequestId = 0;

export function searchTable(search) {
  return async (dispatch, getState) => {
    // Generar un ID único para esta petición para evitar colisiones
    const requestId = ++currentSearchRequestId;

    if (!search || search.trim().length < 3) {
      dispatch({
        type: K.SEARCH_TABLE,
        payload: {
          search: search || '',
          searchData: null,
        },
      });
      return;
    }

    const franchiseId = auth.getCurrentUser() ? auth.getCurrentUser().franchiseId : null;
    const term = search.trim();
    const words = term.split(/\s+/).filter(Boolean);

    try {
      let matchedClientIds = [];
      let matchedUserIds = [];

      // 1. Buscar en la colección de clientes (Rápido con índice)
      try {
        const clientQuery = {
          $select: ['_id', 'firstName', 'lastName'],
          $limit: 200,
        };
        if (words.length > 1) {
          clientQuery.$and = words.map((word) => ({
            $or: [
              { firstName: { $regex: word, $options: 'i' } },
              { lastName: { $regex: word, $options: 'i' } },
              { phone: { $regex: word, $options: 'i' } },
              { email: { $regex: word, $options: 'i' } },
            ],
          }));
        } else {
          clientQuery.$or = [
            { firstName: { $regex: term, $options: 'i' } },
            { lastName: { $regex: term, $options: 'i' } },
            { phone: { $regex: term, $options: 'i' } },
            { email: { $regex: term, $options: 'i' } },
          ];
        }
        const clientResults = await feathers.service('clients').find({ query: clientQuery });
        const clientList = clientResults && clientResults.data ? clientResults.data : (Array.isArray(clientResults) ? clientResults : []);
        if (clientList.length > 0) matchedClientIds = clientList.map((c) => c._id || c.id);

      } catch (err) {
        console.warn('Error buscando clientes en searchTable:', err);
      }

      // 1.5 NUEVO: Buscar en la colección de usuarios (Vendedores)
      try {
        const userQuery = {
          $select: ['_id', 'firstName', 'lastName'],
          $limit: 200,
        };
        if (words.length > 1) {
          userQuery.$and = words.map((word) => ({
            $or: [
              { firstName: { $regex: word, $options: 'i' } },
              { lastName: { $regex: word, $options: 'i' } },
            ],
          }));
        } else {
          userQuery.$or = [
            { firstName: { $regex: term, $options: 'i' } },
            { lastName: { $regex: term, $options: 'i' } },
          ];
        }
        const userResults = await feathers.service('users').find({ query: userQuery });
        const userList = userResults && userResults.data ? userResults.data : (Array.isArray(userResults) ? userResults : []);
        if (userList.length > 0) matchedUserIds = userList.map((u) => u._id || u.id);
      } catch (err) {
        console.warn('Error buscando usuarios en searchTable:', err);
      }


      // 2. Armar query ultra rápida en sales
      let orConditions = [];

      if (matchedClientIds.length > 0) {
        // Si encontramos clientes, buscamos directamente por sus IDs (Usa índice = ultra rápido)
        orConditions.push({ clientId: { $in: matchedClientIds } });
      }

      // NUEVO: Si encontramos vendedores con ese nombre, incluirlos en la búsqueda de ventas
      if (matchedUserIds.length > 0) {
        orConditions.push({ 'salesInformation.assignedTo': { $in: matchedUserIds } });
        orConditions.push({ assignedTo: { $in: matchedUserIds } });
      }

      // También permitir buscar por folio o destino
      orConditions.push({ folio: { $regex: term, $options: 'i' } });
      orConditions.push({ prefolio: { $regex: term, $options: 'i' } });
      orConditions.push({ 'salesInformation.destination': { $regex: term, $options: 'i' } });

      const query = {
        franchiseId: franchiseId,
        $or: orConditions,
        $sort: { createdAt: -1 },
        $limit: 60, // Límite amplio para resultados de búsqueda
        $select: [
          'createdAt',
          'dateSaleNote',
          'folio',
          'prefolio',
          'salesInformation.destination',
          'operatorsList',
          'operatorsPaymentSale',
          'delete',
          'balance.totalPrice',
          'balance.totalDebit',
          'balance.totalBuyPrice',
          'balance.otherExpenses',
          'balance.commissions',
          'balance.totalOperatorPayed',
          'salesInformation.assignedTo',
          'clientId',
          'assignedTo',
        ],
        $populate: [
          {
            path: 'clientId',
            select: ['firstName', 'lastName'],
            match: { _id: { $ne: null } },
          },
          {
            path: 'salesInformation.assignedTo',
            select: ['firstName', 'lastName'],
            match: { _id: { $ne: null } },
          },
          {
            path: 'assignedTo',
            select: ['firstName', 'lastName'],
          },
        ],
      };

      const result = await feathers.service('sales').find({ query });

      // Si llegó otra búsqueda más nueva mientras esta se procesaba, descartar esta
      if (requestId !== currentSearchRequestId) {
        return;
      }

      let salesList = result && result.data ? result.data : (Array.isArray(result) ? result : []);

      // 4. Ordenar y filtrar por relevancia exacta con Fuse
      if (salesList.length > 0) {
        const options = {
          threshold: 0.4,
          location: 0,
          distance: 100,
          keys: [
            'client.firstName',
            'client.lastName',
            'clientId.firstName',
            'clientId.lastName',
            'folio',
            'prefolio',
            'salesInformation.destination',
            'salesInformation.interest',
          ],
        };
        const fuse = new Fuse(salesList, options);
        const fuseResults = fuse.search(term);
        if (fuseResults && fuseResults.length > 0) {
          salesList = fuseResults;
        }
      }

      dispatch({
        type: K.SEARCH_TABLE,
        payload: {
          search: search,
          searchData: salesList,
        },
      });
    } catch (error) {
      console.error('Error en búsqueda global searchTable:', error);
      // Fallback a Fuse local si la llamada falla
      const options = {
        threshold: 0.4,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: [
          'salesInformation.destination',
          'salesInformation.interest',
          'balance.totalPrice',
          'balance.totalDebit',
          'user.firstName',
          'user.lastName',
          'client.firstName',
          'client.lastName',
          'clientId.firstName',
          'clientId.lastName',
          'folio',
          'prefolio',
        ],
      };
      const fuse = new Fuse(getState().Sales.data, options);
      const fallbackResult = fuse.search(search);
      dispatch({
        type: K.SEARCH_TABLE,
        payload: {
          search: search,
          searchData: fallbackResult,
        },
      });
    }
  }
}

export function searchTableByDate(path, value, franchiseId) {
  if (value) {
    if (path === 'startDate') {
      startDate = moment(value, 'YYYY-MM-DD')
        .startOf('day')
        .utc()
        .format('YYYY-MM-DD HH:mm:ss');
    } else {
      finalDate = moment(value, 'YYYY-MM-DD')
        .endOf('day')
        .utc()
        .format('YYYY-MM-DD HH:mm:ss');
    }
  } else {
    if (path === 'startDate') {
      startDate = null;
    } else {
      finalDate = null;
    }
  }

  return async (dispatch, getState) => {
    const query = {
      franchiseId: franchiseId,
      $or: [
        {
          createdAt: {
            $gte: startDate,
            $lte: finalDate,
          },
        },
        { dateSaleNote: { $gte: startDate, $lte: finalDate } },
      ],
      $select: [
        'createdAt',
        'dateSaleNote',
        'folio',
        'prefolio',
        'salesInformation.destination',
        'operatorsList',
        'operatorsPaymentSale',
        'delete',
        'balance.totalPrice',
        'balance.totalDebit',
        'balance.totalBuyPrice',
        'balance.otherExpenses',
        'balance.commissions',
        'balance.totalOperatorPayed',
      ],
      $populate: [
        {
          path: 'clientId',
          select: ['firstName', 'lastName'],
          match: { _id: { $ne: null } },
        },
        {
          path: 'salesInformation.assignedTo',
          select: ['firstName', 'lastName'],
          match: { _id: { $ne: null } },
        },
      ],
    }

    if (startDate && finalDate) {
      query.$or = [
        {
          createdAt: {
            $gte: startDate,
            $lte: finalDate,
          },
        },
        { dateSaleNote: { $gte: startDate, $lte: finalDate } },
      ];
    } else if (startDate) {
      query.$or = [
        { createdAt: { $gte: startDate } },
        { dateSaleNote: { $gte: startDate } },
      ];
    } else if (finalDate) {
      query.$or = [
        { createdAt: { $lte: finalDate } },
        { dateSaleNote: { $lte: finalDate } },
      ];
    }

    const result = await feathers.service('sales').find({
      query
    });

    dispatch({
      type: K.SETSTATE,
      payload: result,
    });
  };
}



// WEBPACK FOOTER //
// ./src/views/Sales/redux/SalesActions.jsx